import { Alert, Button } from "@patternfly/react-core";
import React from "react";
import { useAuth } from "./AuthContext";
import { clearLogoutReason, readLogoutReason } from "@app/utils/keycloak";

import bg4k from '@app/bgimages/cas-bg-4k.webp'; // ~3840px wide
import bgDesktop from '@app/bgimages/cas-bg-desktop.webp'; // ~1920px wide
import bgMobile from '@app/bgimages/cas-bg-mobile.webp'; // ~600px wide

export const LandingPage: React.FC = () => {
  const { keycloak } = useAuth();

  // Read, do not consume: under StrictMode a lazy initialiser runs twice, and a
  // destructive read would throw the reason away before it is rendered.
  const [logoutReason] = React.useState(readLogoutReason);

  // Clearing on mount rather than on unmount means the news is told once and does
  // not survive a reload, which is what the user would expect from a banner about
  // something they just did.
  React.useEffect(clearLogoutReason, []);

  const handleLogin = () => {
    keycloak.login();
  };

  return (
    <div className="cas-landing-container">
      {/* Responsive Image */}
      <img 
        src={bgDesktop} 
        srcSet={`
          ${bgMobile} 640w,
          ${bgDesktop} 1920w,
          ${bg4k} 3840w
        `}
        sizes="100vw"
        alt="Classroom collaboration" 
        className="cas-bg-image" 
        {...{ fetchpriority: "high" } as any}
      />

      {/* Overlay Content */}
      <div className="cas-content-wrapper">
        
        {/* --- 2. Add the Alerts --- */}
        <div style={{ marginBottom: '20px', width: '100%', maxWidth: '400px' }}>
          {logoutReason === 'expired' && (
            <Alert 
              variant="warning" 
              title="Session Expired" 
              isInline
            >
              Your session has timed out due to inactivity. Please log in again to continue.
            </Alert>
          )}

          {logoutReason === 'logged-out' && (
            <Alert 
              variant="success" 
              title="Logged Out" 
              isInline
            >
              You have been successfully logged out.
            </Alert>
          )}
        </div>
        {/* ----------------------- */}

        <div className="cas-text-block">
          <p className="cas-welcome">Welcome to</p>
          <h1 className="cas-acronym">CAS</h1>
          <p className="cas-subtitle">Class Allocation System</p>
        </div>
        
        <Button 
          variant="danger" 
          className="cas-login-btn"
          onClick={handleLogin}
        >
          Log in
        </Button>
      </div>
    </div>
  );
};